export default __webpack_public_path__ + "static/media/dropdown.7a047ea9.svg";